import styled from 'styled-components';

export const Wrapper = styled.div`
	margin-top: 30px;
	width: 100%;
`;

export const ContainerTitle = styled.div`
	max-width: 330px;
	padding: 0 20px;

	@media (min-width: 1100px) {
		margin-top: -75px;
	}
`;

export const ContainerInfo = styled.div`
	display: grid;
	grid-template-columns: auto 350px;
	gap: 20px;
	margin: 45px 0 40px;
	padding: 0 20px;
`;

export const Info = styled.div`
	display: grid;
	grid-template-columns: 1fr;
`;

export const Title = styled.p<{ variant?: boolean }>`
	font-family: 'Montserrat', 'Arial', sans-serif;
	font-style: normal;
	font-weight: ${({ variant }) => (variant ? 400 : 600)};
	font-size: ${({ variant }) => (variant ? '18px' : '20px')};
	line-height: ${({ variant }) => (variant ? '24px' : '21px')};
	color: ${({ variant }) => (variant ? '#64778f' : '#5082C2')};
	max-width: 640px;
`;

export const Content = styled.div`
	margin-top: 40px;
	position: relative;
`;

export const ContainerSearch = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 30px;
`;

export const ActionSearch = styled.div`
	display: grid;
	grid-template-columns: auto 45px;
	place-items: end;
	gap: 6px;

	div {
		width: 100%;
	}
`;

export const ContainerTable = styled.div`
	width: 88vw;
	margin-top: 40px;
`;

export const Description = styled.div<{ variant?: boolean }>`
	font-weight: ${({ variant }) => (variant ? 400 : 600)};
	color: #64778f;
	white-space: nowrap;
	width: 300px;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: ${({ variant }) => (variant ? '12px' : '14px')};
	height: unset;
`;

export const Container = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	position: relative;
`;

export const LayoutPage = styled.div`
	display: grid;
	width: 100%;
	background-color: white;
	padding: 20px;
`;

export const ReferContainer = styled.div`
	display: flex;
	justify-content: right;
	margin-top: 30px;
	place-items: end;
	gap: 50px;
`;

export const ReferAmount = styled.span`
	font-weight: 700;
	font-size: 18px;
	line-height: 22px;
	height: 30px;
	display: flex;
	align-items: center;
	color: #5082c2;
`;

export const FooterContainer = styled.div`
	display: grid;
	grid-template-columns: 50% 50%;
	padding: 20px;
`;

export const NameContainer = styled.div`
	cursor: pointer;
`;
